/**
 * Single Variant Option - Handle price modifier visibility
 * Shows/hides the price modifier based on selected option
 */

document.addEventListener('DOMContentLoaded', function() {
  // Find all variant selectors with price modifiers
  const variantContainers = document.querySelectorAll('.select-container-with-price');
  
  variantContainers.forEach(container => {
    const priceModifier = container.querySelector('.option-price-modifier');
    const radioInputs = container.querySelectorAll('input[type="radio"]');
    
    if (!priceModifier || !radioInputs.length) return;
    
    // Add change event listener to each radio button
    radioInputs.forEach(radio => {
      radio.addEventListener('change', function() {
        if (this.checked) {
          // Show price modifier only if this option has data-shows-price="true"
          if (this.dataset.showsPrice === 'true') {
            priceModifier.style.display = 'block';
          } else {
            priceModifier.style.display = 'none';
          }
        }
      });
    });
  });
});

